import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * Compone clases de Tailwind resolviendo conflictos.
 *
 * `clsx` aplana condicionales; `twMerge` decide quién gana cuando dos utilidades
 * tocan la misma propiedad — sin él, `cn("p-2", "p-4")` deja las dos en el
 * atributo y el resultado depende del orden en la hoja compilada, que es
 * exactamente el tipo de bug que no se reproduce.
 */
export function cn(...clases: ClassValue[]): string {
  return twMerge(clsx(clases))
}
